export default __webpack_public_path__ + "static/guster-623a71318aa8f2dbc15a12c88a5796e9.jpg";